import { render, staticRenderFns } from "./PoolTalentInterestedNotificationListItem.vue?vue&type=template&id=2357b698&scoped=true&"
import script from "./PoolTalentInterestedNotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./PoolTalentInterestedNotificationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PoolTalentInterestedNotificationListItem.vue?vue&type=style&index=0&id=2357b698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357b698",
  null
  
)

/* custom blocks */
import block0 from "./PoolTalentInterestedNotificationListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports